import { useQuery, useReactiveVar } from '@apollo/client'
import { useParams } from 'react-router-dom'
import styled from 'styled-components'

import { CHECK_FOR_CUSTOM_COVER } from 'data/layoutcreator/queries/cover'
import { customCoverRefreshCountVar } from 'data/store/cover'
import {
  EDITOR_PANEL_SIDE_MARGIN,
  EDITOR_PANEL_WIDTH
} from 'shared/consts'
import { CoverSides } from 'shared/types/global'
import { usePdfPreviewImage } from 'shared/hooks/usePdfPreviewImage'
import { Skeleton } from 'shared/ui/Skeleton'

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.color.base.c1};
  padding-left: ${EDITOR_PANEL_SIDE_MARGIN + EDITOR_PANEL_WIDTH}px;
`

const Image = styled.img`
  height: 60%;
  width: auto;
`

const CustomCoverPreview = ({ side }: { side: CoverSides }) => {
  const { projectId } = useParams()

  const { data: checkForCustomCoverData } = useQuery(
    CHECK_FOR_CUSTOM_COVER,
    {
      variables: {
        projectId: projectId!
      }
    }
  )

  const customCoverRefreshCount = useReactiveVar(
    customCoverRefreshCountVar
  )

  const path = (
    checkForCustomCoverData?.checkForCustomCover as any
  )?.[side === CoverSides.inside ? 'inside' : 'outside']

  const rawPreviewUrl = path
    ? `${process.env.REACT_APP_REST_URL}${path}${
        path.includes('?') ? '&' : '?'
      }refreshCount=${customCoverRefreshCount}`
    : ''
  const { previewUrl, isLoading } = usePdfPreviewImage(
    rawPreviewUrl,
    {
      pageNumber: 1,
      scale: 1.5
    }
  )
  const showSkeleton =
    Boolean(rawPreviewUrl) && (isLoading || !previewUrl)

  return (
    <Container>
      {showSkeleton ? (
        <Skeleton height="60%" width="60%" radius={8} />
      ) : (
        <Image src={previewUrl || ''} />
      )}
    </Container>
  )
}

export default CustomCoverPreview
